import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChartData, ChartOptions } from 'chart.js';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';

@Component({
  selector: 'app-member-survey',
  templateUrl: './member-survey.component.html',
  styleUrl: './member-survey.component.scss'
})
export class MemberSurveyComponent {
  @ViewChild("AddSurvey") AddSurvey: ElementRef;
  @ViewChild("AddQuestion", { static: true }) AddQuestionModal: ElementRef;
  @ViewChild("Tag", { static: true }) taqModal: ElementRef;


  public form: FormGroup = new FormGroup({
    id: new FormControl(""),
    title: new FormControl("", [Validators.required]),
    type: new FormControl("", [Validators.required]),
    description: new FormControl("", [Validators.required]),
    startDate: new FormControl("", [Validators.required]),
    endDate: new FormControl("", [Validators.required]),
  });

  public questionForm: FormGroup = new FormGroup({
    id: new FormControl(""),
    question_text: new FormControl("", [Validators.required]),
    question_type: new FormControl("", [Validators.required]),
    options: new FormControl(""),
    position: new FormControl("", [Validators.required]),
  });

  public tagForm: FormGroup = new FormGroup({
    id: new FormControl(""),
    interest_name: new FormControl("", [Validators.required]),
    description: new FormControl(""),
  });

  public answerKeyword = '';
  public selectedTag = '';
  public questionOptions: Array<any> = [];
  public selMenu = 'questions';
  public allList: Array<any> = [];
  public allQuestionList: Array<any> = [];
  public allTagList: Array<any> = [];
  public allSurveyQuestionList: Array<any> = [];
  public allInterestsList: Array<any> = [];
  public allInterestsListDropdown: Array<any> = [];
  public selected: any = null;
  public commonModal: any = null;


  // Charts
  // Define chart options
  chartOptions: ChartOptions = {
    responsive: true,
  };

  // Define chart data
  surveyData: ChartData<'bar'> = {
    labels: ['Option 1', 'Option 2', 'Option 3'],  // Replace with fetched options
    datasets: [
      {
        label: 'Survey Responses',
        data: [30, 15, 55],  // Replace with fetched counts from the database
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)'
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)'
        ],
        borderWidth: 1
      }
    ]
  };


  constructor(private auth: AuthServiceService, private toastr: ToastrService, public modalService: NgbModal) {
    this._getAllList();

  }

  ngOnInit(): void {
  }

  public saveSurvey() {
    this.auth.addMemberSurvey({
      id: this.form.get('id').value || null,
      title: this.form.get('title').value,
      type: this.form.get('type').value,
      description: this.form.get('description').value,
      startDate: new Date(this.form.get('startDate').value).getTime(),
      endDate: new Date(this.form.get('endDate').value).getTime(),
    }).subscribe((resp: ApiResponse) => {
      this.commonModal ? this.commonModal.close() : '';
      this.toastr.success(resp.message);
      this.reset();
      this._getAllList();
    })
  }

  public saveTag() {
    this.auth.addMemberSurveyInterest({
      id: this.tagForm.get('id').value || null,
      interest_name: this.tagForm.get('interest_name').value,
      description: this.tagForm.get('description').value,
    }).subscribe((resp: ApiResponse) => {
      this.commonModal ? this.commonModal.close() : '';
      this.toastr.success(resp.message);
      this.tagForm.reset();
      this._getAllList();
    })
  }

  public saveQuestion() {
    if (this.questionForm.valid) {
      this.auth.addMemberSurveyQuestions({
        id: this.questionForm.get('id').value || null,
        survey_id: this.selected?.id,
        position: this.questionForm.get('position').value,
        question_type: this.questionForm.get('question_type').value,
        question_text: this.questionForm.get('question_text').value,
        options: this.questionOptions
      }).subscribe((resp: ApiResponse) => {
        this.questionOptions = [];
        this.questionForm.reset();
        this.toastr.success(resp.message);
        this._getAllList();
        this.getAllMemberSurveyQuestionsBaseOnSurvey(this.selected.id);
      })
    } else {
      this.toastr.error("Invalid Form!");
    }
  }

  public _getAllList() {
    this.auth.getAllMemberSurvey().subscribe((resp: ApiResponse) => {
      this.allList = resp.body;
    });
    this.auth.getAllMemberSurveyQuestions().subscribe((resp: ApiResponse) => {
      this.allQuestionList = resp.body;
    });
    this.auth.getAllMemberSurveyInterest().subscribe((resp: ApiResponse) => {
      this.allInterestsList = resp.body.map((i) => {
        i.value = i.id;
        i.label = `${i.interest_name}`;
        return i
      });
      this.allInterestsListDropdown = this.allInterestsList.filter((i) => i.type == 'common');
    });
  }

  public reset() {
    this.form.patchValue({
      id: "",
      templateName: "",
      subject: "",
      body: "",
    });
    this.selected = null;
  }

  public removeSurvey(id) {
    this.auth.deleteMemberSurvey(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getAllList();
      this.reset();
    })
  }

  public removeQuestion(id) {
    this.auth.deleteMemberSurveyQuestions(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getAllList();
    })
  }

  public removeTag(id) {
    this.auth.deleteMemberSurveyInterest(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getAllList();
    })
  }

  public selectMenu(menu: string) {
    this.selMenu = menu;
  }

  public openSurveyAddEdit(selected: any = null) {
    if (selected) {
      this.selected = selected;
      this.form.patchValue({
        id: selected?.id,
        title: selected?.title,
        type: selected?.type,
        description: selected?.description,
        startDate: new Date(selected?.startDate),
        endDate: new Date(selected?.endDate),
      });
    } else {
      this.form.reset();

      this.selected = null;
    }
    this.commonModal = this.modalService.open(this.AddSurvey, {
      size: "xs",
      backdrop: "static",
      windowClass: "suggestion",
    });
  }

  public addQuestionOption() {
    if (this.questionForm.get("options").value) {
      this.questionOptions.push(this.questionForm.get("options").value);
      this.questionForm.get("options").setValue("");
    }

  }

  public openQuestionAddEdit(selected: any = null) {
    this.questionForm.reset();
    this.questionOptions = [];
    this.questionForm.get('question_type').setValue('');
    if (selected) {
      this.selected = selected;
      // this.for.patchValue({
      //   id: selected?.id,
      //   question_text: selected?.question_text,
      //   question_type: selected?.question_type,
      //   options: selected?.options,
      // });
    }
    this.commonModal = this.modalService.open(this.AddQuestionModal, {
      size: "lg",
      backdrop: "static",
    });

    this.getAllMemberSurveyQuestionsBaseOnSurvey(selected.id);
  }


  public openTagAddEdit(selected: any = null) {
    this.questionForm.reset();
    this.questionOptions = [];
    this.questionForm.get('question_type').setValue('');
    if (selected) {
      this.selected = selected;
      this.tagForm.patchValue({
        id: selected?.id,
        interest_name: selected?.interest_name.toUpperCase(),
        description: selected?.description,
      });
    }
    this.commonModal = this.modalService.open(this.taqModal, {
      size: "xs",
      backdrop: "static",
    });
  }

  public assignTag(modal: any = null, item) {
    this.selected = item;
    this.commonModal = this.modalService.open(modal, {
      size: "xs",
      backdrop: "static",
    });
  }

  public getAllMemberSurveyQuestionsBaseOnSurvey(surveyid) {
    this.auth.getAllMemberSurveyQuestionsBaseOnSurvey({ survey_id: surveyid }).subscribe((resp: ApiResponse) => {
      this.allSurveyQuestionList = resp.body;
    });
  }


  public editQuestion(item) {
    this.questionOptions = [];
    this.questionForm.patchValue({
      id: item?.id,
      question_text: item?.question_text,
      question_type: item?.question_type,
      position: item?.position,
    });
    this.questionOptions = item?.options || [];
  }

  public newQuestion() {
    this.questionOptions = [];
    this.questionForm.reset();
    this.questionForm.get('question_type').setValue('');
  }

  public getResponse(modal, surveyid) {
    this.commonModal = this.modalService.open(modal, {
      size: "xs",
      backdrop: "static",
    });
    this.auth.getAllMemberSurveyQuestionsBaseOnSurvey({ survey_id: surveyid }).subscribe((resp: ApiResponse) => {

      this.auth.getAllMemberSurveyResponses({ question_id: resp.body.filter((i) => i.survey_id == surveyid).map((i) => i.id) }).subscribe((response: ApiResponse) => {
        this.surveyData = {
          labels: response.body.map((i) => i.selected_option),  // e.g., ['Option 1', 'Option 2', 'Option 3']
          datasets: [
            {
              label: 'Survey Responses',
              data: response.body.data.map((i) => i.response_count),  // e.g., [30, 15, 55]
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)'
              ],
              borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)'
              ],
              borderWidth: 1
            }
          ]
        };
      });
    });

  }

  public handleSelectedTag(event) {
    this.selectedTag = event.value;
  }

  public saveAssignTag() {
    this.auth.addMemberSurveyQuestionAnswerInterestMapping({
      question_id: this.selected.id,
      answer_option: this.answerKeyword,
      interest_id: this.selectedTag,
    }).subscribe((resp: ApiResponse) => {
      this.selectedTag = '';
      this.answerKeyword = '';
      this.toastr.success(resp.message);
      this._getAllList();
    })
  }

  public removeTagMapping(id) {
    this.auth.deleteMemberSurveyQuestionAnswerInterestMapping(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getAllList();
      this.reset();
    })
  }

  public handleTagType(event) {
    this.allInterestsListDropdown = this.allInterestsList.filter((i) => i.type == event.target.value.toLowerCase());
  }
}
